<div class="filter-modal" id="filter-modal" [ngStyle]="styleModal">
  <div class="filter-wrapper">
    <div class="filter-body">
      <div class="filter-modal-items">
        <div class="li-filter-lv2">
          <div class="lv2-margin" *ngIf="(itemList?.length ?? 0) > 0">
            <caremoni-checkbox class="check-all" [value]="isCheckAll" (onClick)="checkAll($event)">
            </caremoni-checkbox>
            <label class="lbl margin-text" >{{SCREEN_TITLE_CONFIG.CHECKALL}}</label>
          </div>
        </div>
        <ul class="child-item">
          <li class="li-filter-lv2" *ngFor="let child of itemList; let index = index">
            <div [ngClass]="index === 0? 'lv2-margin': ''">
              <caremoni-checkbox *ngIf="!child?.isLabel" class="check-all" [value]="child.checked"
                (click)="checkItem(child)">
              </caremoni-checkbox>
              <label class="lbl" [ngClass]="child?.isLabel? 'margin-label' : 'margin-text'"> {{child.name}}</label>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="filter-footer">
      <caremoni-button class="cancel-btn" (click)="closeModal()" [buttonText]="BUTTON.CLOSE">
      </caremoni-button>
      <caremoni-button (click)="onSave()" [buttonText]="BUTTON.SAVE">
      </caremoni-button>
    </div>
  </div>
</div>